<template>
  <v-container class="pt-15">
    <!-- <v-row justify="center">
      <v-col cols="auto">
        <p
          class="text-body-2 text-sm-body-1 text-left"
          v-html="t('heroImage.em_note')"
        ></p>
        <p class="text-body-2 text-sm-body-1 text-left" v-html="em_note"></p>
      </v-col>
    </v-row> -->
    <v-row class="main-heading mt-10" justify="center">
      <v-col cols="12" sm="11" md="11" lg="9" xl="7">
        <h1 class="title text-center" v-html="$t('main_heading.title')"></h1>
        <h2 v-if="showSubtitle" class="subtitle text-center mt-6">
          {{ $t("main_heading.subtitle") }}
        </h2>
        <p
          class="lead text-body-1 text-md-body-1 mt-7"
          v-html="$t('main_heading.description')"
        ></p>

      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { useI18n } from "vue-i18n";
import LocaleData from "@/locales/MainHeading";

const { t, locale } = useI18n();
const localizedData = computed(() => LocaleData[locale.value]);

const props = defineProps({
  showSubtitle: {
    type: Boolean,
    default: true,
  },
});

const em_note = "naked-nijojo<span class='display-none'>4k3-f385ljd</span>@naked.works";
</script>

<style lang="scss" scoped>
.main-heading {
  .title {
    font-family: "source-han-serif-japanese", serif;
    font-size: 24px;
    font-weight: 700;
    font-style: normal;
    line-height: 1.5;
    @media screen and (min-width: 600px) {
      font-size: 40px;
    }
  }

  .subtitle {
    font-family: "source-han-serif-japanese", serif;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 1.7;
    @media screen and (min-width: 600px) {
      font-size: 20px;
    }
  }

  .lead {
    line-height: 1.7;
  }
}
</style>
